import { useState } from "react";
import type { PrintSize } from "../queries/bill.queries";

const STORAGE_KEY = "billme_last_print_size";
const DEFAULT_SIZE: PrintSize = "a4";

function readStoredSize(): PrintSize {
	const stored = localStorage.getItem(STORAGE_KEY);
	return (stored as PrintSize) || DEFAULT_SIZE;
}

// Remembers the last size a user picked in PrintOptionsDialog so repeat
// prints default to it instead of always resetting to "a4".
export function useLastPrintSize(): [PrintSize, (size: PrintSize) => void] {
	const [size, setSizeState] = useState<PrintSize>(readStoredSize);

	const setSize = (next: PrintSize) => {
		setSizeState(next);
		localStorage.setItem(STORAGE_KEY, next);
	};

	return [size, setSize];
}
